<template>
  <div class="loadError">
    <div class="sub">
      <span :style="{color:textColor}">{{loadErrorText}}</span>
      <p class="cursor" :class="{myselfBadge: btnstyle}" :style="errBtnStyle" @click="loadAgain">点击重试</p>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    loadErrorText: {
      default: "课程信息获取失败，请点击按钮重新加载～",
      type: String,
      required: false
    },
    textColor: {
      type: String,
      required: false,
      default:"#ffffff"
    },
    btnstyle: {
      default: false,
      type: Boolean
    },
    errBtnStyle:{
        type: Object,
        default:()=>{
          return {}
        }
    }
  },
  methods: {
    loadAgain() {
      let pageName = "";
      this.$emit("loadAgain");
      switch (this.$route.name) {
        case "myselfBadge":
          pageName = "个人中心页";
          break;
        case "class":
          pageName = "首页";
          break;
        case "course":
          pageName = "课时列表页";
          break;
      }
       this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventFailureButton",
        data: {
          page:pageName
        }
      });
    }
  },
  computed: {
		...mapState([
			"subject"
		])
	}
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.loadError {
  position: absolute;
  z-index: 40;
  top: 0;
  width: 100%;
  height: 100%;
  .sub {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 550px;
    margin-top:-40px;
    transform: translate(-50%, -50%);
    .myselfBadge{
      background: #1eb3ff;
      &:hover{
        background: #12abf9;
        color: #99d8f9;
      }
    }
  }
  span{
    opacity: .75;
  }
  span,
  p {
    display: block;
    color: #ffffff;
    font-size: 24px;
  }
  p {
    display: inline-block;
    width: 160px;
    height: 60px;
    line-height: 60px;
    margin-top: 20px;
    // background:#0B92B8;
    background:rgba(255,255,255,0.3);
    border-radius: 6px;
  }
  p:hover {
    // background: #006581;
    // color: #B5D1D9;
    color:#fff;
    background:rgba(255,255,255,0.2);
  }
  p:hover{
    opacity: .8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/loadError.vue